import { render } from "./SwiperBase.vue?vue&type=template&id=16c8f788"
import script from "./SwiperBase.vue?vue&type=script&setup=true&lang=js"
export * from "./SwiperBase.vue?vue&type=script&setup=true&lang=js"

import "./SwiperBase.vue?vue&type=style&index=0&id=16c8f788&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Utility/SwiperBase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16c8f788"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16c8f788', __exports__)) {
    api.reload('16c8f788', __exports__)
  }
  
  module.hot.accept("./SwiperBase.vue?vue&type=template&id=16c8f788", () => {
    api.rerender('16c8f788', render)
  })

}


export default __exports__